//This file is built exclusively for the form functionalities.

import React from "react";
import "./ModalWrapper.css";

const ModalWrapper = ({ show, onClose, children }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      {/* Close button outside the dialog box */}
      <button className="outer-close-btn" onClick={onClose}>
        ✖
      </button>

      <div className="modal-box">
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};

export default ModalWrapper;
